var ProspectOrigins;
(function (ProspectOrigins) {
    ProspectOrigins["ContactScript"] = "contact_script";
    ProspectOrigins["Dashboard"] = "dashboard";
    ProspectOrigins["ChromeExtension"] = "chrome_extension";
    ProspectOrigins["ContactForm"] = "contact_form";
    ProspectOrigins["Appointment"] = "appointment";
    ProspectOrigins["Other"] = "other";
    ProspectOrigins["SGT"] = "sgt";
    ProspectOrigins["CASAChat"] = "calvin";
})(ProspectOrigins || (ProspectOrigins = {}));

export { ProspectOrigins };
